// libs
import React from 'react'
import { useHistory } from 'react-router'

// components
import BackbuttonHeader from 'src/components/header/common/backbutton_header/backbutton_header'
import MoreMenu from 'src/components/header/subheaders/shared_contents/more_menu/more_menu'
import MenuItemSegment from 'src/components/item_segment/layouts/menu/menu'

// constants
import { CLASS_PREFIX } from 'src/constants'

// helpers
import { UrlUtils } from 'src/utils/url/url'

import { textResources } from 'src/lang/de'
import './header_project.scss'

const t = textResources.projects

const cls: string = CLASS_PREFIX + 'header-project'
const clsMoreWrapper = `${cls}__more-wrapper`

interface Props {
  title: string
  parent?: string
  fallbackRoute?: string
  showMoreButton?: boolean
  onEdit?: () => void
}

const HeaderProject: React.FC<Props> = ({
  title,
  fallbackRoute,
  showMoreButton,
  onEdit
}) => {
  const history = useHistory()

  const handleBackButton = () => {
    UrlUtils.goBack(history, fallbackRoute)
  }

  return (
    <div className={cls}>
      <BackbuttonHeader
        title={title}
        handleBackButton={handleBackButton}
      >
        {showMoreButton && onEdit && (
          <div className={clsMoreWrapper}>
            <MoreMenu>
              <MenuItemSegment
                label={t.details.editProject}
                navigation={{ onClick: onEdit }}
              />
            </MoreMenu>
          </div>
        )}
      </BackbuttonHeader>
    </div>
  )
}

export default HeaderProject
